import { IVector2, IVector3 } from '../../../../api.js';
import { GIZMO_AXIS_COLOR, GIZMO_COLOR_FACTOR } from '../GizmoColors.js';
import { MeshDescriptions } from '../MeshDescriptions.js';
export class ScaleCenter {
    constructor(viewer, transform_handling) {
        this.transform_handling = transform_handling;
        this._viewer = viewer;
        const color = GIZMO_AXIS_COLOR.center;
        const box_mesh_description = MeshDescriptions.create_cube(0.20, color);
        this._ui_mesh = this._viewer.create_ui_mesh();
        this._ui_mesh.load_mesh(box_mesh_description);
        this.gizmo = this._ui_mesh.create_gizmo();
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.not_active;
        this.add_event_listeners();
        this._ui_mesh.draw_on_top = true;
    }
    add_event_listeners() {
        this.gizmo.pointer_enter_observable.add(this.on_pointer_over.bind(this));
        this.gizmo.drag_begin_observable.add(this.on_drag_start.bind(this));
        this.gizmo.drag_observable.add(this.on_drag.bind(this));
        this.gizmo.pointer_leave_observable.add(this.on_pointer_leave.bind(this));
    }
    on_pointer_over() {
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.active;
    }
    on_drag_start(_, event) {
        var _a, _b;
        this._initial_point = new IVector2(event.canvas_x, event.canvas_y);
        this._initial_scale = this.transform_handling.scale.get();
        if (this.transform_handling.get_world_transform) {
            const world_matrix = this.transform_handling.get_world_transform();
            this._object_on_canvas = (_a = this._viewer.project_world_position_to_canvas(world_matrix[3].x, world_matrix[3].y, world_matrix[3].z)) !== null && _a !== void 0 ? _a : undefined;
        }
        else {
            const { x, y, z } = this.transform_handling.position.get();
            this._object_on_canvas = (_b = this._viewer.project_world_position_to_canvas(x, y, z)) !== null && _b !== void 0 ? _b : undefined;
        }
    }
    on_drag(_, event) {
        if (!this._initial_point || !this._initial_scale || !this._object_on_canvas)
            return;
        const current_point = new IVector2(event.canvas_x, event.canvas_y);
        const initial_distance = IVector2.distance(this._initial_point, this._object_on_canvas);
        const current_distance = IVector2.distance(current_point, this._object_on_canvas);
        const factor = current_distance / initial_distance;
        const new_scale = IVector3.scale(this._initial_scale, factor);
        this.transform_handling.scale.set(new_scale);
    }
    on_pointer_leave() {
        this.gizmo.color_factor = GIZMO_COLOR_FACTOR.not_active;
    }
}
//# sourceMappingURL=ScaleCenter.js.map